/**************************************************************************
Name:         global.js
Description:  Site scripting.
Date Created: 12/05/2013 by Kyle Brickman
Modified:
**************************************************************************/

/* Redactor plugin storage */
if( !RedactorPlugins )
	var RedactorPlugins = {};

/* Template support - DO NOT REMOVE */
window.jQuery || document.write( '<script src = "/scripts/jquery.min.js"><\/script>' );

/* Support for information labels */
if( $( 'label[data-info]' ).length )
{
	loadStyleSheets.push( '/css/jquery.info.css' );
	loadScripts.push( '/scripts/jquery.info.js'  );
	loadEvents.push( function( ){
		$( 'label[data-info]' ).info( );
	});
}

/* RequestAnimationFrame polyfill */
Modernizr.load({
	test: Modernizr.prefixed( 'requestAnimationFrame', window ),
	nope: [
		'/scripts/polyfill.requestAnimationFrame.min.js'
	]
});

/* Placeholder polyfill */
Modernizr.load({
	test: Modernizr.input.placeholder,
	nope: [
		'/css/polyfill.placeholder.min.css',
		'/scripts/polyfill.placeholder.min.js'
	]
});

if (typeof(loadAllCSS) === 'undefined') {
	// From https://github.com/filamentgroup/loadCSS/
	var loadCSS = function( href, before, media ){
		// Arguments explained:
		// `href` [REQUIRED] is the URL for your CSS file.
		// `before` [OPTIONAL] is the element the script should use as a reference for injecting our stylesheet <link> before
			// By default, loadCSS attempts to inject the link after the last stylesheet or script in the DOM. However, you might desire a more specific location in your document.
		// `media` [OPTIONAL] is the media type or query of the stylesheet. By default it will be 'all'
		var doc = window.document;
		var ss = doc.createElement( "link" );
		var newMedia = media || "all";
		var ref;
		if( before ){
			ref = before;
		}
		else {
			var refs = ( doc.body || doc.getElementsByTagName( "head" )[ 0 ] ).childNodes;
			ref = refs[ refs.length - 1];
		}

		var sheets = doc.styleSheets;
		ss.rel = "stylesheet";
		ss.href = href;
		// temporarily set media to something inapplicable to ensure it'll fetch without blocking render
		ss.media = "only x";

		// wait until body is defined before injecting link. This ensures a non-blocking load in IE11.
		function ready( cb ){
			if( doc.body ){
				return cb();
			}
			setTimeout(function(){
				ready( cb );
			});
		}
		// Inject link
			// Note: the ternary preserves the existing behavior of "before" argument, but we could choose to change the argument to "after" in a later release and standardize on ref.nextSibling for all refs
			// Note: `insertBefore` is used instead of `appendChild`, for safety re: http://www.paulirish.com/2011/surefire-dom-element-insertion/
		ready( function(){
			ref.parentNode.insertBefore( ss, ( before ? ref : ref.nextSibling ) );
		});
		// A method (exposed on return object for external use) that mimics onload by polling until document.styleSheets until it includes the new sheet.
		var onloadcssdefined = function( cb ){
			var resolvedHref = ss.href;
			var i = sheets.length;
			while( i-- ){
				if( sheets[ i ].href === resolvedHref ){
					return cb();
				}
			}
			setTimeout(function() {
				onloadcssdefined( cb );
			});
		};

		// once loaded, set link's media back to `all` so that the stylesheet applies once it loads
		if( ss.addEventListener ){
			ss.addEventListener( "load", function(){
				this.media = newMedia;
			});
		}
		ss.onloadcssdefined = onloadcssdefined;
		onloadcssdefined(function() {
			if( ss.media !== newMedia ){
				ss.media = newMedia;
			}
		});
		return ss;
	};

	var loadAllCSS = function() {
		/* http://www.paulirish.com/2010/duck-punching-with-jquery/ */
		loadStyleSheets = $.grep( loadStyleSheets, function( value, key ){
			return $.inArray( value, loadStyleSheets ) === key;
		});

		// Start loading style sheets a little early
		for (var i = 0; i < loadStyleSheets.length; i++) {
			loadCSS(loadStyleSheets[i]);
		};

		if (typeof(loadedStyleSheets) === 'undefined') {
			var loadedStyleSheets = [];
		}

		loadedStyleSheets.concat(loadStyleSheets);

		loadStyleSheets = [];
	};
}

loadAllCSS();

/* Mobile and tablet check */
window.mobileAndTabletCheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4)))check = true})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}

/* IE 10 fix */
if ( navigator.appVersion.indexOf('MSIE 10') != -1 )
{
	$( 'html' ).addClass( 'is-ie' );
	$( 'html' ).addClass( 'is-ie10' );
	$( 'html' ).addClass( 'lt-ie11' );
}

/* IE 11 fix */
if ( navigator.appVersion.indexOf('Trident') != -1 && navigator.appVersion.indexOf('rv:11') != -1 )
{
	$( 'html' ).addClass( 'is-ie' );

	if ( navigator.appVersion.indexOf('rv:11') != -1 )
		$( 'html' ).addClass( 'is-ie11' );
}

/* Legacy Android fix */
if( /android/i.test( navigator.userAgent ))
{
	$( 'html' ).addClass( 'is-android' );

	if( !/chrome/i.test(  navigator.userAgent ) &&
	    !/firefox/i.test( navigator.userAgent ) &&
	    !/opera/i.test(   navigator.userAgent ))
		$( 'html' ).addClass( 'is-legacy-android' );
}

/* Legacy ios check */
if( /ip(hone|od|ad)/i.test( navigator.userAgent ))
{
	$( 'html' ).addClass( 'is-ios' );

	var appVersionMatch = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/ );

	if( appVersionMatch != null && 6 >= parseInt( navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/ )[1] ))
		$( 'html' ).addClass( 'is-legacy-ios' );
}

/* Windows 8 check */
function isWindows8() {
	var ua = navigator.userAgent;

	// Match Windows 8 (NT 6.2) and Windows 8.1 (NT 6.3)
	var isWindows8 = /Windows NT 6\.2|Windows NT 6\.3/.test(ua);

	// Exclude ALL Safari and Yandex (YaBrowser) versions to avoid false positives
	var isSafari = /\bSafari\b/.test(ua) && !/Chrome|Chromium|Edg|OPR/.test(ua); // true Safari, not Chrome-based
	var isYandex = /YaBrowser/.test(ua);
	var isLegacyBrowser = isSafari || isYandex;

	return (isWindows8 && !isLegacyBrowser);
}

if (isWindows8()) {
	$( 'html' ).addClass( 'is-windows-8' );
}

/* Sane cookie scope formatting */
var getCookieScope = function( )
{
	var cookieArray = document.cookie.split( ';' );
	var cookieScope = {};

	for( var i = 0; i < cookieArray.length; i++ )
	{
		var currentCookie = $.trim( cookieArray[i] ).split( '=' );
		var currentName   = currentCookie.shift( );
		var currentValue  = currentCookie.join( '=' );

		cookieScope[currentName] = currentValue;
	}

	return cookieScope;
};

 /* Windows touch device support */
/* Support for full site's top navigation on touch devices */
if( navigator.msMaxTouchPoints > 0 || navigator.maxTouchPoints > 0 ){ $( 'html' ).addClass( 'touch' ); }

/* Session expiration notification */
if( !$( 'html' ).hasClass( 'frame' ) || $( 'html' ).hasClass( 'reportBuilderFrame' ) )
{
	var sessionExpiry = $(
		'<div id = "sessionExpiry">' +
			'<div>' +
				'<div>' +
					'<div>Automatic Signout</div>' +
					'<span>You will be automatically signed out in </span>' +
					'<span id = "sessionExpiryTime"></span>' +
					'<span>.  Click "Continue" to continue working, or "Sign Out" to sign out now.</span>' +
					'<a class="buttonAction isDark" data-type="Sign Out" >Sign Out<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg></a>' +
					'<a class="buttonAction isDark" data-type="Continue" >Continue<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg></a>' +
				'</div>' +
			'</div>' +
		'</div>' ).prependTo( 'body' );

	var setSessionExpiry = function( settings )
	{
		var cookieScope = getCookieScope( );
		var expiryTime  = cookieScope.sessionExpiry;
		var currentTime = ( new Date( )).getTime( );
		var leftTime    = Math.floor( ( expiryTime - currentTime - 1000 ) / 1000 );

		if( !parseInt( cookieScope.sessionExpiryActive ))
		{
			clearInterval( sessionExpiryInterval )
			if( parseInt(sessionExpiryActiveOnLoad) )
			{
				window.location.reload( );
			}
			return;
		}

		if( 300 >= leftTime )
			sessionExpiry.addClass( 'active' );
		else
			sessionExpiry.removeClass( 'active' );

		if( 0 >= leftTime )
		{
			forceSessionExpiry( )
			clearInterval( sessionExpiryInterval );
		}

		if( 60 < leftTime )
			leftTime = Math.floor( leftTime / 60 ) + ' minute' + ( Math.floor( leftTime / 60 ) != 1 ? 's' : '' );
		else
			leftTime += ' second' + ( leftTime != 1 ? 's' : '' );

		$( '#sessionExpiryTime' ).text( leftTime )
	};

	var resetSessionExpiry = function( )
	{
		//$.ajax( '/cfcs/siteGW.cfc?method=ping' );

		$.ajax({
			url      : '/cfcs/siteGW.cfc',
			cache    : false,
			dataType : 'json',
			data     : '&method=timeoutPing',
			success  : function( result ){
				if( result[0].active == false )
					forceSessionExpiry( );
			}
		});

	};

	var forceSessionExpiry = function( )
	{
		$( window ).off( 'beforeunload' );
		window.location = $( 'a[href$="signout/"]' ).first( ).attr( 'href' );
	};

	var sessionExpiryActiveOnLoad = getCookieScope().sessionExpiryActive;

	var sessionExpiryInterval = setInterval( setSessionExpiry, 1000 );

	sessionExpiry.on( 'click', 'a.buttonAction[data-type="Continue"]', resetSessionExpiry );
	sessionExpiry.on( 'click', 'a.buttonAction[data-type="Sign Out"]', forceSessionExpiry );

	loadEvents.push( function( ){
		$( window ).focus( function( ) {
			var cookieScope 		= getCookieScope( );
			var sessionExpiryActive = cookieScope.sessionExpiryActive;

			if( !sessionExpiryActive ) window.location.reload( );
		});
	});
}

placeHolderConfig = {
	className                       : 'placeholder',
	visibleToScreenreaders          : true,
	visibleToScreenreadersHideClass : 'placeholder-hide-except-screenreader',
	visibleToNoneHideClass          : 'placeholder-hide',
	hideOnFocus                     : true,
	removeLabelClass                : 'visuallyhidden',
	hiddenOverrideClass             : 'visuallyhidden-with-placeholder',
	forceHiddenOverride             : true,
	forceApply                      : false,
	autoInit                        : true
};

loadEvents.unshift( function( ){
	initializeFormElements( $( 'input, select, textarea' ));
});

var initializeFormElements = function( set )
{
	set.filter( 'input[placeholder], select[placeholder], textarea[placeholder]' ).each( function( ){
		$( this ).attr( 'title', $( this ).attr( 'placeholder' ));
	});

	set.filter( 'select[placeholder]' ).each( function( ){
		var select     = $( this );
		var attributes = '';
		var setValue   = false;

		select.on( 'click', placeholdFocus );
		select.on( 'change blur', placeholdBlur );

		if( '' != select.attr( 'optional' ))
			attributes += ' disabled';

		if( !$( 'option[selected]', select ).length )
		{
			attributes += ' selected';
			select.addClass( 'placeheld' );
			setValue = true;
		}

		var detached = $( '*', select ).detach( );

		$( '<option value = ""' + attributes + '>' + select.attr( 'placeholder' ) + '</option>' ).prependTo( select );

		detached.appendTo( select );

		var selectedOptions = $( 'option[selected]', select );
		if( selectedOptions.length )
		{
			selectedOptions = selectedOptions.last( );
			select.val( selectedOptions.val( ));
			select.get( 0 ).selectedIndex = $( 'option', select ).index( selectedOptions );
		}
		else
		{
			select.val( '' );
			select.get( 0 ).selectedIndex = 0;
		}
	});

	// set.filter( 'input[error], textarea[error]' ).on( 'keyup', function( ){
	// 	if( $( this ).val( ).trim( ) != $( this ).attr( 'error' ))
	// 		$( this ).addClass( 'pass' );
	// 	else
	// 		$( this ).removeClass( 'pass' );
	// });

	set.filter( 'input[type="file"].custom' ).on( 'change', function( ){
		var input = $( this );
		var label = $( 'label[for="' + input.attr( 'id' ) + '"]' );
		var filename = input.val( ).split( '/' ).pop( ).split( '\\' ).pop( );

		label.addClass( 'noplaceholder' ).text( filename );
	});
};

var textFields = document.querySelectorAll(".textField");
textFields.forEach(function(textField) {
	textField.addEventListener("input", function() {
		var wrapper = this.closest(".textFieldWrapper");

		if(this.value.length) {
			wrapper.classList.add("hasValue");
		} else {
			wrapper.classList.remove("hasValue");
		}
	});
});

var placeholdFocus = function( )
{
	var select = $( this );

	if( !$( 'html.lt-ie10' ).length )
		select.removeClass( 'placeheld' );
};

var placeholdBlur = function( )
{
	var select = $( this );

	select.removeClass( 'placeheld' );

	if( 0 == select.get( 0 ).selectedIndex )
		select.addClass( 'placeheld' );
};

/* Resizes fieldsets to maximum row height */
var resizeFieldsets = function( )
{
	var fieldsets = $( 'fieldset' ).filter( ':visible' ).not( '.controls' );
	var currentTop    = 0;
	var currentHeight = 0;

	fieldsets.height( 'auto' );

	for( var i = 0; i < fieldsets.length; i++ )
	{
		var thisFieldset = $( fieldsets[i] )
		var thisTop      = resizeFieldsetsPosition( thisFieldset );
		var thisHeight   = thisFieldset.height( );
		var thisMargin   = resizeFieldsetsMargin( thisFieldset );

		if( thisTop == currentTop )
		{
			if( thisHeight > currentHeight )
			{
				currentHeight = thisHeight;

				for( var j = i; j >= 0; j-- )
				{

					if( resizeFieldsetsPosition( fieldsets[j] ) == thisTop ) {
						var currentMargin = resizeFieldsetsMargin( fieldsets[j] );

						if( currentMargin )
							$( fieldsets[j] ).height( currentHeight - currentMargin );
						else
							$( fieldsets[j] ).height( currentHeight );
					} else {
						j = 0;
					}
				}
			}

			if( thisHeight < currentHeight )
				thisFieldset.height( currentHeight - thisMargin + 1 ); /* + 1 is a fix for Firefox and IE */
		}
		else
		{
			currentTop    = thisTop;
			currentHeight = thisHeight;
		}
	}
}

var resizeFieldsetsPosition = function( fieldset )
{
	var thisFieldset = $( fieldset );
	var thisTop      = thisFieldset.offset( ).top;
	var thisMargin   = resizeFieldsetsMargin( thisFieldset );

	thisTop -= thisMargin;

	return thisTop;
}

var resizeFieldsetsMargin = function( fieldset )
{
	var thisFieldset = $( fieldset );
	var thisMargin   = 0;

	if( undefined != thisFieldset.css( 'margin-top' ))
	{
		var tempMargin = thisFieldset.css( 'margin-top' ).replace( /[^\d.-]/g, '' );

		if( tempMargin.length )
			thisMargin = parseFloat( tempMargin );
	}

	return thisMargin;
}

loadEvents[loadEvents.length] = function( ){
	if( $( 'fieldset' ).not( '.controls' ).length )
	{
		$( window ).on( 'orientationchange resize', resizeFieldsets );
		resizeFieldsets( );
	}
}

/* Supports cross-viewport communication */
var triggerParentEvent = function( selector, eventType, extraParameters )
{
	if( undefined == extraParameters )
		extraParameters = {};

	$( selector ).trigger( eventType, extraParameters );
}

/* Supports tree-like tables */
var toggleChildRows = function( evt )
{
	evt.preventDefault( );

	var parentA     = $( this );
	var parentTR    = parentA.parent( ).parent( );
	var parentTBODY = parentTR.parent( );
	var parentTABLE = parentTBODY.parent( );
	var parentID    = parentTR.attr( 'data-id' );
	var parentTABLENUM = -1;

	if( parentTABLE.parents( '.pinned' ).length ){
		var parentTABLENUM = parentTABLE.parents( '.pinned' ).attr( 'tablenum' );
		if( typeof parentTABLENUM != 'undefined' && parentTABLENUM !== false ){
			parentTABLE = $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table,div.scrollable[tablenum="' + parentTABLENUM + '"] table' );
			parentTBODY = $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table tbody,div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody' );
		}
	}

	if( 'Collapse' == parentA.attr( 'title' ))
	{
		var children = $( 'tr', parentTBODY ).filter( '[data-parent^="' + parentID + '"]' );

		children.hide( );

		$( 'a.collapse', children ).removeClass( 'collapse' ).addClass( 'expand' ).attr( 'title', 'Expand' ).text( 'Expand' );
		parentA.removeClass( 'collapse' ).addClass( 'expand' ).attr( 'title', 'Expand' ).text( 'Expand' );
	}
	else
	{
		var children = $( 'tr', parentTBODY ).filter( '[data-parent="' + parentID + '"]' );

		children.show( );
		parentA.removeClass( 'expand' ).addClass( 'collapse' ).attr( 'title', 'Collapse' ).text( 'Collapse' );
	}

	// Candy striping support
	if( !parentTABLE.hasClass( 'nostripe' ))
	{
		$( 'tr' ).removeClass( );

		var stripeIndex = 0;
		if( parentTABLE.parents( '.pinned' ).length ){
			$( 'tr', $( 'div.pinned[tablenum="' + parentTABLENUM + '"] table tbody' ) ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
			stripeIndex = 0;
			$( 'tr', $( 'div.scrollable[tablenum="' + parentTABLENUM + '"] table tbody' ) ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
		}else{
			$( 'tr', parentTBODY ).not( ':hidden' ).each( function( index ){
				stripeIndex += 1;
				$( this ).addClass( 0 == stripeIndex % 2 ? 'evenChild' : 'oddChild' );
			});
		}
	}

	writeTreeSessionStorage( parentTABLE );
}

var writeTreeSessionStorage = function( parentTABLE )
{
	// HTML5 session storage
	if( 'undefined' !== typeof( Storage ))
	{
		var path       = window.location.pathname.replace( /\//g, '_' );
		var dataID     = [];
		var dataStatus = [];


		sessionStorage[ 'tree' + path ] = '';

		$( 'tr[data-id]', parentTABLE ).each( function( index ){
			dataID[        dataID.length] = $( this ).attr( 'data-id' );
			dataStatus[dataStatus.length] = $( 'a', $( this )).first( ).hasClass( 'collapse' );
		})

		dataID     =     dataID.join( ',' );
		dataStatus = dataStatus.join( ',' );

		sessionStorage[ 'tree' + path ] +=     dataID + '|';
		sessionStorage[ 'tree' + path ] += dataStatus + '|';
	}
};

var readTreeSessionStorage = function( parentTABLE )
{
	var path = window.location.pathname.replace( /\//g, '_' );

	// HTML5 session storage
	if( 'undefined' !== typeof( Storage ) && sessionStorage[ 'tree' + path ])
	{
		var dataID     = sessionStorage[ 'tree' + path ].split( '|' )[0].split( ',' );
		var dataStatus = sessionStorage[ 'tree' + path ].split( '|' )[1].split( ',' );

		$( 'tr[data-id]', parentTABLE ).hide( );
		$( 'tr[data-id] a.inline.collapse' ).text( 'Expand' ).attr( 'title', 'Expand' ).removeClass( 'collapse' ).addClass( 'expand' );
		$( 'tr[data-id]', parentTABLE ).first( ).show( );

		for( var i = 0; i < dataID.length; i++ )
		{
			if( 'true' === dataStatus[i] )
				$( 'tr[data-id="' + dataID[i] + '"] a.inline.expand' ).trigger( 'click' );
		}
	}
	else
	{
		$( 'a.inline.collapse', parentTABLE ).first( ).trigger( 'click' ).trigger( 'click' );
	}
}

/* Sets up a proxy for row links */
var rowLinkProxy = function( evt )
{
	if( $( evt.target ).hasClass('skipLinkProxy') || $( evt.target ).parent().hasClass('skipLinkProxy') )
		return;

	evt.preventDefault( );

	var row = $( this );

	if( row.hasClass( 'linkproxy' ) || undefined == evt.data.selector )
		return;

	var link = row.find( evt.data.selector );

	if( !link.length || ( undefined == evt.data.calling && undefined == link.attr( 'href' )))
		return;

	row.addClass( 'linkproxy' );

	var linkTarget = link.attr( 'target' );

	if( undefined == linkTarget )
		linkTarget = '_self';

	// if( undefined == evt.data.calling )
		switch( linkTarget )
		{
			case '_blank':
				evt.data.calling = function( ){
					window.open( link.attr( 'href' ));
				}
				break;
			case '_self':
				evt.data.calling = function( ){
					window.location = link.attr( 'href' );
				}
				break;
			case '_parent':
				evt.data.calling = function( ){
					window.parent.location = link.attr( 'href' );
				}
				break;
			case '_top':
				evt.data.calling = function( ){
					window.top.location = link.attr( 'href' );
				}
				break;
			default:
				evt.data.calling = function( ){
					var iframe = $( 'iframe[name=""]' );

					if( iframe.length )
						iframe[0].href = link.attr( 'href' );
				}
				break;
		}

	link.one( 'click', evt.data.calling ).trigger( 'click' );

	row.removeClass( 'linkproxy' );
}

/* Displays a confirmation banner */
var displayConfirmationBanner = function( evt )
{
	evt.preventDefault( );

	$('p.banner').remove();

	var target    = $( evt.target   );
	var banner    = $( '<p />'      );
	var textContainer   = $( '<div />' );
	var buttonContainer = $( '<div />' );
	var yesButton = $( '<a />'  );
	var noButton  = $( '<a />'  );
	var articleH2  	 = $( 'article h2' ).first( );
	var progressbar  = $( 'ul#progressbar' ).not('ul.registrationBar');
	var breadcrumb 	 = $( 'ul#breadcrumb' );
	var instructions = $( 'div#instructions' );
	var appStatus	 = $( 'div.appStatus' );
	var customWarning = $('#customWarning');

	if( instructions.length )
		var after = instructions;
	else if( customWarning.length )
		var after = customWarning;
	else if( appStatus.length )
		var after = appStatus;
	else if( progressbar.length )
		var after = progressbar;
	else if	( articleH2.length )
		var after = articleH2;
	else
		var after = $( 'article h1' );

	after = after.first( );

	banner.addClass( 'banner'  );
	banner.addClass( 'example' );

	textContainer.addClass( 'textContainer' );
	textContainer.html( target.attr( 'data-message' ) ? target.attr( 'data-message' ) : target.attr( 'title' ) ? target.attr( 'title' ) : target.attr( 'href' ));
	textContainer.appendTo( banner );

	buttonContainer.addClass( 'bannerButtonContainer' );

	yesButton.attr( 'data-type', 'Yes' ); yesButton.text( 'Yes' );
	 noButton.attr( 'data-type',  'No' );  noButton.text( 'No' );

	yesButton.addClass('buttonAction isDark');
	noButton.addClass('buttonAction isDark');

	yesButton.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');
	noButton.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');

	yesButton.on( 'click', function( evt ){
		if( undefined != target.attr( 'data-submit' ) && 'true' == target.attr( 'data-submit' ))
			target.closest( 'form' ).get( 0 ).submit( )
		else
			window.location = target.attr( 'href' );

		closeAlertBanner( evt );
	});
	noButton.on( 'click', closeAlertBanner );

	 noButton.prependTo( buttonContainer );
	yesButton.prependTo( buttonContainer );

	buttonContainer.appendTo( banner );

	banner.insertAfter( after );

	var position = ( banner.position( ).top + banner.outerHeight( )) * -1;

	var mobileOffset = 0;
	if(appStatus.length && $( window ).width() <= 568)
		mobileOffset = 460;

	banner.css( 'top', position + 'px' );

	if( customWarning.length )
	{
		$('html, body').animate({ scrollTop: customWarning.offset().top }, 0);
	}
	else
	{
		if( breadcrumb.length )
			$('html, body').animate({ scrollTop: breadcrumb.offset().top + mobileOffset }, 0);
		else
			$('html, body').animate({ scrollTop: 0 }, 100);
	}

	banner.animate({ top: 0, marginBottom: 10 }, 400 );
};

var displayConfirmationBannerDirect = function( data )
{
	// Remove existing click events from banner
	$('p.banner').off('click');

	// Remove existing click events from banner children
	$('p.banner').find('*').off('click');

	// Remove existing banner
	$('p.banner').remove();

	var banner    = $( '<p />'      );
	var textContainer   = $( '<div />' );
	var buttonContainer = $( '<div />' );
	var yesButton = $( '<a />'  );
	var noButton  = $( '<a />'  );
	var articleH2  	 = $( 'article h2' ).first( );
	var progressbar  = $( 'ul#progressbar' ).not('ul.registrationBar');
	var breadcrumb 	 = $( 'ul#breadcrumb' );
	var instructions = $( 'div#instructions' );
	var appStatus	 = $( 'div.appStatus' );
	var customWarning = $('#customWarning');

	if( instructions.length )
		var after = instructions;
	else if( customWarning.length )
		var after = customWarning;
	else if( appStatus.length )
		var after = appStatus;
	else if( progressbar.length )
		var after = progressbar;
	else if	( articleH2.length )
		var after = articleH2;
	else
		var after = $( 'article h1' );

	after = after.first( );

	banner.addClass( 'banner'  );
	banner.addClass( 'example' );

	textContainer.addClass( 'textContainer' );
	textContainer.html( data.message );
	textContainer.appendTo( banner );

	buttonContainer.addClass( 'bannerButtonContainer' );

	yesButton.attr( 'data-type', 'Yes' ); yesButton.text( 'Yes' );
	noButton.attr( 'data-type',  'No' );  noButton.text( 'No' );

	yesButton.addClass('buttonAction isDark');
	noButton.addClass('buttonAction isDark');

	yesButton.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');
	noButton.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');

	yesButton.on( 'click', function(){
		data.confirm = 1;
		closeConfirmationBannerDirect(data);
		return 1;
	});
	noButton.on( 'click', function() {
		data.confirm = 0;
		closeConfirmationBannerDirect(data);
		return 0;
	});

	noButton.prependTo( banner );
	yesButton.prependTo( banner );

	noButton.prependTo( buttonContainer );
	yesButton.prependTo( buttonContainer );

	buttonContainer.appendTo( banner );

	banner.insertAfter( after );

	var position = ( banner.position( ).top + banner.outerHeight( )) * -1;

	var mobileOffset = 0;
	if(appStatus.length && $( window ).width() <= 568)
		mobileOffset = 460;

	banner.css( 'top', position + 'px' );

	if( customWarning.length )
	{
		$('html, body').animate({ scrollTop: customWarning.offset().top }, 0);
	}
	else
	{
		if( breadcrumb.length )
			$('html, body').animate({ scrollTop: breadcrumb.offset().top + mobileOffset }, 0);
		else
			$('html, body').animate({ scrollTop: 0 }, 100);
	}

	banner.animate({ top: 0, marginBottom: 10 }, 400 );
};

var closeConfirmationBannerDirect = function(data)
{
	var banner = $('p.banner');
	var position = ( banner.position( ).top + banner.outerHeight( )) * -1;
	banner.animate({ top: position, marginBottom: -42 }, 400, function( ){ banner.remove( ); });

	if(data.confirm && data.yesCallback != null) {
		data.yesCallback(data);
	}
	else if(!data.confirm && data.noCallback != null) {
		data.noCallback(data);
	}
}


/* Displays an alert banner */
var displaySuccessBanner = function( msg ){ displayAlertBanner( msg, 'success' ); };
var displayWarningBanner = function( msg ){ displayAlertBanner( msg, 'warning' ); };
var displayFailureBanner = function( msg ){ displayAlertBanner( msg, 'failure' ); };
var displayExampleBanner = function( msg ){ displayAlertBanner( msg, 'example' ); };
var displayNoticeBanner = function( msg ){ displayAlertBanner( msg, 'notice' ); };

var displayAlertBanner = function( msg, type )
{
	$('p.banner').remove();

	var banner = $( '<p />' );
	var textContainer = $( '<div />' );
	var close  = $( '<a />' );
	var articleH2  	 = $( 'article h2:not(.signin)' ).first( );
	var progressbar  = $( 'ul#progressbar' ).not('ul.registrationBar');
	var progressbar2 = $( 'div.progressbar' );
	var breadcrumb 	 = $( 'ul#breadcrumb' );
	var instructions = $( 'div#instructions' );
	var appStatus	 = $( 'div.appStatus' );
	var displayBannerHook = $('#displayBannerHook');

	if( displayBannerHook.length )
		var after = displayBannerHook;
	else if ( breadcrumb.length )
		var after = breadcrumb;
	else if( instructions.length )
		var after = instructions;
	else if( appStatus.length )
		var after = appStatus;
	else if( progressbar.length )
		var after = progressbar;
	else if( progressbar2.length )
		var after = progressbar2;
	else if	( articleH2.length )
		var after = articleH2;
	else
		var after = $( 'article h1' );

	if( undefined == type || ( 'example' != type && 'success' != type && 'warning' != type && 'failure' != type && 'notice' != type ))
		type = 'example';

	banner.addClass( 'banner' );
	banner.addClass( type     );

	textContainer.addClass( 'textContainer' );
	textContainer.html( msg );
	textContainer.appendTo( banner );

	close.addClass( 'close icon' );
	close.text(     'Close' );
	close.load('/images/icons/svg/cancel.svg');
	close.attr( 'href',  '#'     );
	close.attr( 'title', 'Close' );
	close.on( 'click', closeAlertBanner );

	if( type != 'notice' && type != 'example' )
		close.prependTo( banner );

	banner.insertAfter( after );

	var position = ( banner.position( ).top + banner.outerHeight( )) * -1;

	banner.css( 'top', position + 'px' );

	if( breadcrumb.length )
		$('html, body').animate({ scrollTop: breadcrumb.offset().top }, 0);
	else
		$('html, body').animate({ scrollTop: 0 }, 100);

	banner.animate({ top: 0, marginBottom: 10 }, 400 );

};

/* Closes an alert or confirmation banner */
var closeAlertBanner = function( evt )
{
	evt.preventDefault( );

	var target = $( evt.currentTarget );
	var banner = target.parents( 'p.banner' );
	var position = ( banner.position( ).top + banner.outerHeight( )) * -1;

	banner.animate({ top: position, marginBottom: -42 }, 400, function( ){ banner.remove( ); });
}

/* Displays an alert toast */
var successToast = function( msg ){ displayToast( msg, 'success' ); };
var warningToast = function( msg ){ displayToast( msg, 'warning' ); };
var failureToast = function( msg ){ displayToast( msg, 'failure' ); };
var exampleToast = function( msg ){ displayToast( msg, 'example' ); };

var displayToast = function( msg, type )
{
	$( 'div.toast' ).trigger( 'toast.hide' );

	var toast = $( '<div />' );

	toast.addClass( 'toast ' + type );
	toast.html( msg );

	toast.on( 'toast.show', showToast );
	// toast.on( 'toast.grow', growToast );
	toast.on( 'toast.hide', hideToast );

	toast.prependTo( 'body' );

	setTimeout( function( ){ toast.trigger( 'toast.show' ); },   10 );
	// setTimeout( function( ){ toast.trigger( 'toast.grow' ); },  510 );
	setTimeout( function( ){ toast.trigger( 'toast.hide' ); }, 5510 );
};

var showToast = function( )
{
	$( this ).addClass( 'showToast' );
};

var growToast = function( )
{
	$( this ).addClass( 'growToast' );
};

var hideToast = function( )
{
	var toast = $( this );

	toast.addClass( 'hideToast' );

	toast.off( 'toast.show' );
	toast.off( 'toast.grow' );
	toast.off( 'toast.hide' );

	setTimeout( function( ){
		toast.remove( );
	}, 510 );
};

/* Displays a yes/no alert toast */
var successConfirm = function( msg, url, callback ){ displayConfirm({ message : msg, type : 'success' }); };
var warningConfirm = function( msg, url, callback ){ displayConfirm({ message : msg, type : 'warning', 'callback': callback }); };
var failureConfirm = function( msg, url, callback ){ displayConfirm({ message : msg, type : 'failure' }); };
var exampleConfirm = function( msg, url, callback ){ displayConfirm({ message : msg, type : 'example' }); };

/* Displays an ok alert toast */
var successAlert = function( msg ) { displayConfirm({ message : msg, type : 'success' }); };
var warningAlert = function( msg ) { displayConfirm({ message : msg, type : 'warning' }); };
var failureAlert = function( msg, title, buttonType ) { displayConfirm({ message : msg, type : 'failure', title : title, buttonType : buttonType }); };
var exampleAlert = function( msg, titles, links ) { displayConfirm({ message : msg, type : 'example', title : 'Oops...', linkTitle : titles, linkHref : links }); };

/* Displays a note modal */
var noteModal = function( elementID )
{
	var textarea = $( '#' + elementID );

	var attributes = {
		title      : textarea.attr( 'data-note-title'    ),
		message    : textarea.attr( 'data-note-message'  ),
		type       : textarea.attr( 'data-note-type'     ),
		url        : textarea.attr( 'data-note-url'      ),
		callback   : textarea.attr( 'data-note-callback' ),
		textarea   : textarea.attr( 'data-note-textarea'  ),
		autoselect : textarea.attr( 'data-note-autoselect'  ),
		className  : textarea.attr( 'data-note-className'  ),
		topSpace   : $(textarea).offset().top
	}
}

var eventConfirm = function( evt )
{
	evt.preventDefault( );

	var link = $( this );

	var attributes = {
		title      	: link.attr( 'data-confirm-title'      	),
		message    	: link.attr( 'data-confirm-message'    	),
		type       	: link.attr( 'data-confirm-type'       	),
		url        	: link.attr( 'data-confirm-url'        	),
		callback   	: link.attr( 'data-confirm-callback'   	),
		textarea   	: link.attr( 'data-confirm-textarea'   	),
		autoselect 	: link.attr( 'data-confirm-autoselect' 	),
		className  	: link.attr( 'data-confirm-className'  	),
		hasCancel  	: link.attr( 'data-confirm-hasCancel'   ),
		setTextarea : link.attr( 'data-confirm-setTextarea' ),
		modalFields : link.attr( 'data-confirm-modalFields' ),
		addMargin   : link.attr( 'data-confirm-addMargin'   ),
		topSpace   	: $(link).offset().top

	};

	if( undefined == attributes.url )
		attributes.url = link.attr( 'href' );

	var settings = {
		element : this,
		target  : this.ownerDocument.defaultView || this.ownerDocument.parentWindow
	};

	if( undefined != attributes.title       ) settings.title    	= attributes.title;
	if( undefined != attributes.message     ) settings.message  	= attributes.message;
	if( undefined != attributes.type       	) settings.type     	= attributes.type;
	if( undefined != attributes.url         ) settings.url      	= attributes.url;
	if( undefined != attributes.callback    ) settings.callback 	= attributes.callback;
	if( undefined != attributes.textarea    ) settings.textarea 	= attributes.textarea;
	if( undefined != attributes.autoselect 	) settings.autoselect 	= attributes.autoselect;
	if( undefined != attributes.className  	) settings.className  	= attributes.className;
	if( undefined != attributes.hasCancel  	) settings.hasCancel  	= attributes.hasCancel;
	if( undefined != attributes.setTextarea ) settings.setTextarea 	= attributes.setTextarea;
	if( undefined != attributes.topSpace   	) settings.topSpace   	= attributes.topSpace;
	if( undefined != attributes.modalFields ) settings.modalFields  = attributes.modalFields;
	if( undefined != attributes.addMargin 	) settings.addMargin  	= attributes.addMargin;

	displayConfirm( settings );
};

var displayConfirm = function( settings )
{

	/* Hide existing dialogs */
	$( 'div.confirm' ).trigger( 'confirm.hide' );

	/* Parameterize arguments */
	settings = $.extend({
		title        : '',
		message    	 : '',
		type       	 : '',
		element      : window,
		target       : window,
		url        	 : '',
		callback   	 : '',
		initCallback: function(){},
		directCallback: function(){},
		yesCallback: function(){},
		noCallback: function(){},
		linkTitle  	 : '',
		linkHref   	 : '',
		textarea   	 : '',
		autoselect 	 : '',
		className  	 : '',
		hasCancel  	 : false,
		setTextarea  : false,
		topSpace   	 : '',
		buttonType 	 : '',
		buttonTextYes: 'Yes',
		buttonTextNo: 'No',
		buttonTextOk: 'OK',
		buttonTextCancel: 'Cancel',
		modalFields  : false,
		addMargin    : false,
		verticalAlign: '',
	}, settings );

	settings.title     = $.trim( settings.title     );
	settings.message   = $.trim( settings.message   );
	settings.type      = $.trim( settings.type      );
	settings.url       = $.trim( settings.url       );
	settings.callback  = $.trim( settings.callback  );
	settings.linkTitle = $.trim( settings.linkTitle );
	settings.linkHref  = $.trim( settings.linkHref  );

	var confirm = $( '<div   />' );
	var center  = $( '<div   />' );
	var modal   = $( '<div   />' );
	var title   = $( '<div   />' );
	var message = $( '<span  />' );
	var links   = $( '<span  />' );
	var yes     = $( '<a />' );
	var no      = $( '<a />' );
	var ok 		= $( '<a />' );
	var cancel  = $( '<a />' );

	confirm.addClass( 'confirm' );

	if( settings.className.length ) {
		confirm.addClass( settings.className );
	}

	if( settings.type.length ) {
		confirm.addClass( settings.type );
	}

	if( settings.linkTitle.length ) {
		var titleArray = settings.linkTitle.split( ',' );
		var hrefArray  = settings.linkHref.split(  ',' );
		var link 	   = '';

		for( var i = 0; i < titleArray.length; i++ ){
			link += '<br /><a href = "' + hrefArray[i] + '" title = "' + titleArray[i] + '" target = "_blank">' + titleArray[i] + '</a>';
		}

		links.html( link );
	};

	   yes.attr( 'data-type', settings.buttonTextYes ).text( settings.buttonTextYes ).addClass( 'confirmButtonYes' );
	 	no.attr( 'data-type', settings.buttonTextNo ).text( settings.buttonTextNo ).addClass( 'confirmButtonNo' );
	 	ok.attr( 'data-type', settings.buttonTextOk ).text( settings.buttonTextOk ).addClass( 'confirmButtonOk' );
	cancel.attr( 'data-type', settings.buttonTextCancel ).text( settings.buttonTextCancel ).addClass( 'confirmButtonCancel' );

	yes.addClass('buttonAction isDark');
	no.addClass('buttonAction isDark');
	ok.addClass('buttonAction isDark');
	cancel.addClass('buttonAction isDark');

	yes.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');
	no.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');
	ok.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');
	cancel.append('<svg xmlns="http://www.w3.org/2000/svg" class = "svgArrow" viewBox="0 0 22 22"><path d="m5.657 4.949 10.606 10.607M16.556 4.949v11.314M5.657 15.263h9.899"/></svg>');

	  title.html( settings.title   );
	message.html( settings.message );

	confirm.on( 'confirm.show', showConfirm );
	confirm.on( 'confirm.hide', hideConfirm );

	yes.on( 'click', function( ){
		$( this ).closest( 'div.confirm' ).trigger( 'confirm.hide' );

		if( settings.callback.length )
			settings.target[settings.callback].call( settings.element );

		if( settings.url.length )
			settings.target.location = settings.url;

		settings.directCallback();
		settings.yesCallback();
	})

	no.on( 'click', function( ){
		$( this ).closest( 'div.confirm' ).trigger( 'confirm.hide' );

		settings.noCallback();
	})

	ok.on( 'click', function( ){
		$( this ).closest( 'div.confirm' ).trigger( 'confirm.hide' );

		if( settings.textarea.length && settings.setTextarea )
		{
			var textarea = $('#' + settings.textarea);

			textarea.detach( ).appendTo( $( 'body' ).find( 'form' ));
		}

		if( settings.modalFields.length && settings.modalFields )
		{
			var modalElements = $( this ).closest( 'div.confirm' ).children('div');

			$('div.modalFields').remove();
			modalElements.detach( ).appendTo( $( 'body' ).find( 'form' ));
		}

		if( settings.callback.length )
			settings.target[settings.callback].call( settings.element );

		if( settings.url.length )
			settings.target.location = settings.url;
	})

	cancel.on( 'click', function( ) {
		$( this ).closest( 'div.confirm' ).trigger( 'confirm.hide' );

		if( settings.textarea.length && settings.setTextarea )
		{
			var textarea = $('#' + settings.textarea);

			textarea.detach( ).css( 'display', 'none' ).appendTo( $( 'body' ).find( 'form' ));
		}
	})

	if( settings.title.length      )   title.appendTo( modal );
	if( settings.message.length    ) message.appendTo( modal );
	if( settings.linkTitle.length  )   links.appendTo( modal );

	//Add text area
	if( settings.textarea.length )
	{
		if( settings.setTextarea ) {
			var textarea = $('#' + settings.textarea);
			textarea.detach( );
		} else
			var textarea = $('#' + settings.textarea).clone();

		textarea.css('display', 'block');
		textarea.appendTo( modal );
	}

	if( settings.modalFields ) {

		modal.append( $('div.modalFields').html() );
	}

	if( settings.hasCancel ) {
		ok.addClass( 'right' );
		cancel.appendTo( modal );
	}

	if( settings.buttonType == 'ok' ) {
		ok.appendTo( modal );
	}
	else if ( settings.buttonType == 'yesno' ) {
		no.appendTo( modal );
		yes.appendTo( modal );
	}
	else
	{
		if( settings.type != 'example' )      no.appendTo( modal );
		if( settings.type != 'example' )     yes.appendTo( modal );
		if( settings.type == 'example' )      ok.appendTo( modal );
	}

	if (typeof(settings.verticalAlign) === 'string' && settings.verticalAlign.length > 0) {
		center.css('vertical-align', settings.verticalAlign);
	}

	if (typeof(settings.topSpace) === 'string' && settings.topSpace.length > 0) {
		modal.css('margin-top', settings.topSpace);
	}

	  modal.appendTo(  center );
	 center.appendTo( confirm );
	confirm.prependTo( 'body' );

	//moves down the pop up, within the modal curtain
	//confirm.find("div").eq(0).css('margin-top', settings.topSpace);

	if( settings.addMargin && $( 'body' ).hasClass( 'tabContainer' ))
	{
		var scrollPos 	= $( window.parent.document ).scrollTop( ),
			modalHeight = modal.height( ),
			margin      = scrollPos - modalHeight;

		modal.css( 'margin-top', margin + 'px' );
	}

	//Select text area
	if( settings.textarea.length && settings.autoselect.length && (settings.autoselect == 'true' || settings.autoselect == 'TRUE') )
		textarea.select();

	setTimeout( function( ) {
		confirm.trigger( 'confirm.show' );
		settings.initCallback();
	}, 10 );
};

var showConfirm = function( )
{
	$( this ).addClass( 'showConfirm' );
};

var hideConfirm = function( )
{
	var confirm = $( this );

	confirm.addClass( 'hideConfirm' );

	confirm.off( 'confirm.show' );
	confirm.off( 'confirm.hide' );

	confirm.find( 'input' ).off( 'click' );

	setTimeout( function( ){
		confirm.remove( );
	}, 510 );
};

var formatCommas = function( inputVal )
{
	var x = inputVal;
    return x.toString().replace(/[^0-9.]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

//Format decimal or dollar value
var formatDecimal = function( x, dollarSign, addCommas )
{
	if( typeof addCommas == 'undefined' ) addCommas = false;

    //Format decimal places
	var x = parseFloat(Math.round(x * 100) / 100).toFixed(2)

	//Check for negative value
	if( x < 0 )
		var isNegative = true;
	else
		var isNegative = false;

	//Replace non-numeric
	x = x.replace(/[^0-9.]/g, "");

	//Add commas
	// x = x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	if( addCommas ) x = formatCommas( x.toString() );

	//Add dollar sign
	if( dollarSign )
		x = '$' + x;

	//Add parenthesis
	if( isNegative )
		x = '(' + x + ')';

	return x;
};

var getOrdinal = function( n ) {
	if ( n >= 10 && n < 20 ) {
		return n + "th";
	} else {
		var digit = n % 10;

		switch(digit) {
			case 1:
				return n + "st";
			case 2:
				return n + "nd";
			case 3:
				return n + "rd";
			default:
				return n + "th";
		}
	}
};

/* Support for stateful windows */
var windowID = '';
var setWindowID = function( id )
{
	windowID = id;
	window.name = windowID;
	document.cookie = 'windowID=; path=/';

	$( window ).on( 'beforeunload', function( ){
		document.cookie = 'windowID=' + windowID + '; path=/';
	});
}

/* Support for incompatibility warnings */
$( 'div.incompatible a.close' ).on( 'click', function( evt ){
	evt.preventDefault( );
	$( this ).parent( ).addClass( 'hidden' );
	document.cookie = 'incompatible=warned';
})

if( $( 'html.is-ios' ).length )
	$( 'input:not([type="checkbox"],[type="radio"],[type="file"]), textarea, select' ).on( 'focus', function( ){
		if( !$( this ).parent( ).closest( 'header.portrait' ).length )
			$( 'html' ).addClass( 'textfocus' );
	}).on( 'blur', function( ){
		$( 'html' ).removeClass( 'textfocus' );
	});

$( window ).off( 'resize' );

/* Support for FOUT elimination */
loadEvents.push( function( ){
	$( '[data-unstyled]' ).removeAttr( 'data-unstyled' );
});

var executeLoadEvents = function( )
{
	var returnAfter = loadEvents.length;
	//returnAfter = 7;

	for( var i = 0; i < returnAfter; i++ )
	{
		loadEvents[i]( );
	}
};

Number.isInteger = Number.isInteger || function(value) {
    return typeof value === "number" &&
           isFinite(value) &&
           Math.floor(value) === value;
};

/* http://www.paulirish.com/2010/duck-punching-with-jquery/ */
loadScripts = $.grep( loadScripts, function( value, key ){
	return $.inArray( value, loadScripts ) === key;
});

if( loadScripts.length )
	Modernizr.load({
		test: false,
		nope: loadScripts,
		complete : executeLoadEvents
	});
else
	executeLoadEvents( );


$('div.cornerRibbon').mouseover(function() {
	$(this).hide();
});